module.exports = __webpack_public_path__ + "static/media/builtinv2-slow spped.bbf32f45.png";